import { useRef } from 'react';
import Checkbox from '@/components/Checkbox';

const CheckboxCell = ({ row, column, value, onChange }) => {
  const cellRef = useRef(null);
  const isEditable = column.editable !== false;
  const checked = Boolean(value);

  const handleToggle = () => {
    if (!isEditable || !onChange) {
      return;
    }

    const newValue = !checked;
    onChange(newValue, { row, column });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <div
      className={`comp-grid-table-cell checkbox-cell ${isEditable ? 'editable' : 'read-only'} ${column.cellClassName || ''}`}
      onClick={(e) => {
        e.stopPropagation();
        handleToggle();
      }}
      ref={cellRef}
      tabIndex={isEditable ? 0 : -1}
      onKeyDown={handleKeyDown}
      role="checkbox"
      aria-checked={checked}>
      <Checkbox active={checked} onClick={handleToggle} title={column.checkboxLabel} />
    </div>
  );
};

export default CheckboxCell;
